// extracted by mini-css-extract-plugin
export default {"th":"WalletReitsList_th__oVdum","td":"WalletReitsList_td__x8YkE","emphasis":"WalletReitsList_emphasis__7X4MI"};